import { isFunction, isObject, isSymbol } from 'lodash';
import { ignoreCycle } from './tools';
export var ReturnType;
(function (ReturnType) {
    ReturnType["Normal"] = "normal";
    ReturnType["Promise"] = "promise";
})(ReturnType || (ReturnType = {}));
export const createKeyGen = () => {
    let p = 0;
    const genKey = () => {
        const key = p;
        p = p + 1;
        return key;
    };
    return genKey;
};
export class LogCollector {
    logMap = {};
    visitMap = {};
    getKey = createKeyGen();
    waitMap = {};
    addIntercept(obj, name) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const that = this;
        return new Proxy(obj, {
            get(target, p, receiver) {
                const val = Reflect.get(target, p, receiver);
                if (isSymbol(p)) {
                    return val;
                }
                const mergedPath = `${name}${name ? '.' : ''}${p}`;
                const originalData = target[p];
                that.collectPropertyVisit(mergedPath, val);
                if (isFunction(originalData)) {
                    const func = function (...args) {
                        let error;
                        let ret;
                        const start = Date.now();
                        try {
                            ret = originalData.apply(this, args);
                        }
                        catch (err) {
                            error = err;
                        }
                        const callInfo = {
                            start,
                            args,
                            error: error?.toString?.(),
                            ret,
                            returnType: ReturnType.Normal,
                        };
                        that.collectFuncCall(mergedPath, callInfo);
                        if (error) {
                            throw error;
                        }
                        if (!(ret instanceof Promise) && isObject(ret)) {
                            return that.addIntercept(ret, `${mergedPath}()`);
                        }
                        return ret;
                    };
                    Object.assign(func, originalData);
                    return that.addIntercept(func, mergedPath);
                }
                if (isObject(originalData)) {
                    return that.addIntercept(originalData, mergedPath);
                }
                return val;
            },
        });
    }
    getVisitMap() {
        return ignoreCycle(this.visitMap);
    }
    async getLogMap() {
        await Promise.all(Object.values(this.waitMap));
        const processed = Object.fromEntries(Object.entries(this.logMap).map(([key, calls]) => [
            key,
            calls.map((info) => {
                const clone = { ...info };
                if (clone.ret && clone.ret._isVue === true && clone.ret.$el) {
                    clone.ret = 'vue Component';
                }
                if (clone.resolveData && clone.resolveData._isVue === true && clone.resolveData.$el) {
                    clone.resolveData = 'vue Component';
                }
                return clone;
            }),
        ]));
        return ignoreCycle(processed);
    }
    collectPropertyVisit(path, val) {
        const { visitMap } = this;
        if (!visitMap[path]) {
            visitMap[path] = [];
        }
        visitMap[path].push(val);
    }
    collectFuncCall(path, callInfo) {
        const { logMap, waitMap } = this;
        if (!logMap[path]) {
            logMap[path] = [];
        }
        const bucket = logMap[path];
        bucket.push(callInfo);
        const patchCallInfo = {};
        if (callInfo.ret instanceof Promise) {
            patchCallInfo.returnType = ReturnType.Promise;
            patchCallInfo.ret = undefined;
            const wait = callInfo.ret.then((data) => {
                patchCallInfo.resolveData = data;
            }, (e) => {
                patchCallInfo.rejectInfo = e?.toString?.() ?? e;
            });
            const key = this.getKey();
            waitMap[key] = Promise.resolve(wait).then(() => {
                patchCallInfo.cost = Date.now() - callInfo.start;
                Object.assign(callInfo, patchCallInfo);
                delete waitMap[key];
            });
        }
    }
}
